import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'checkout-ticket-empty',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './ticket-empty.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketEmptyComponent {}
